import { IconArrowRight, TablerIcon } from "@tabler/icons-react";
import classNames from "classnames";
import { JSX, PropsWithoutRef, ReactNode } from "react";
import { Link } from "react-router";
import styles from "./ServiceCard.module.scss";

export type Service = {
  description: string;
  detail: ReactNode;
  icon: TablerIcon;
  iconWrapperClassName: string;
  link: string;
  title: string;
};

type ServiceCardProps = Overwrite<PropsWithoutRef<JSX.IntrinsicElements["div"]>, {
  service: Service;
}>;

export default function ServiceCard({ className, service, ...props }: ServiceCardProps) {
  return (
    <div {...props} className={classNames("col d-flex flex-column", className)}>
      <div className="border-0 card h-100 overflow-hidden rounded-4 shadow-lg">
        <div className="card-body d-flex flex-column p-16">
          <div className="align-items-center d-flex flex-row gap-8">
            <div
              className={classNames(
                "align-items-center d-flex flex-shrink-0 justify-content-center rounded-3 size-3rem text-inverted",
                service.iconWrapperClassName,
                styles.iconWrapper,
              )}
            >
              <service.icon size="2rem" />
            </div>

            <div className="overflow-hidden">
              <h2 className="fs-5 fw-semi-bold mb-0">{service.title}</h2>

              <div className="fw-medium mt-1 text-body-tertiary">{service.description}</div>
            </div>
          </div>

          <div className="mt-10 text-body-secondary">{service.detail}</div>

          <div className="mt-auto pt-8" />


          <Link
            className="align-items-center bg-primary-focus-visible bg-primary-hover bg-opacity-10-focus-visible bg-opacity-10-hover
                    border-top d-flex fw-semi-bold mb-n16 me-n16 ms-n16 px-16 py-8 text-decoration-none transition-bg"
            to={service.link}
          >
            <div className="flex-grow-1">Learn more</div>

            <IconArrowRight />
          </Link>
        </div>
      </div>
    </div>
  );
}
